import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MappingService {
  constructor(private http: HttpClient) {}

  mapping(id) {
    return this.http.get(`/projects/${id}/mapping`);
  }

  enableMapping(id, enabled) {
    return this.http.put(`/projects/${id}/settings/mapping`, null, {
      params: { enabled }
    });
  }

  enableShuffle(id, enabled) {
    return this.http.put(`/projects/${id}/settings/random-choice`, null, {
      params: { enabled }
    });
  }

  addNewMapping(id, params) {
    return this.http.post(`/projects/${id}/mapping`, params);
  }

  editMapping(id, params) {
    return this.http.put(`/projects/${id}/mapping`, params);
  }

  remove(id, mappingId) {
    return this.http.delete(`/projects/${id}/mapping/${mappingId}`);
  }
}
